import { Navigate, useLocation } from 'react-router-dom'

import { useSessionGuard } from 'src/app/auth/hooks/use-session-guard'
import { useAuthStore } from 'src/app/auth/interfaces'

export function RequireAuth({ children }: { children: JSX.Element }) {
  // Subscribe to the value that actually changes when an expired session is
  // cleared. Selecting the stable isAuthenticated function does not rerender
  // this guard when currentUser changes, which can leave a protected page
  // mounted indefinitely while its queries display loading skeletons.
  const isAuthenticated = useAuthStore(state => !!state.currentUser)
  const sessionExpired = useAuthStore(state => state.sessionExpired)
  const restoreStatus = useAuthStore(state => state.restoreStatus)
  const location = useLocation()
  useSessionGuard()

  if (isAuthenticated) {
    return children
  }

  if (restoreStatus !== 'done') {
    return null
  }

  return (
    <Navigate
      to="/login"
      state={{ from: location, sessionExpired: !!sessionExpired }}
      replace
    />
  )
}
